<template>
  <!--Short form component-->
  <div :class="[bookie + '-style']" v-if="Object.keys(singleRunner).length > 0 && !isMobile">
    <template v-for="d in singleRunner.competitors">
      <div v-if="d.tabNo == runnerNo" :key="d.tabNo" id="iFrameBox" style="background: none">
        <div class="shortFormContainer">
          <div class="runnerInfo" style="display: flex; justify-content: space-evenly">
            <span>Age: <b>{{d.age}}</b></span>
            <span>Sex: <b>{{d.sex}}</b></span>
            <span>Colour: <b>{{ d.colour.toUpperCase() }}</b></span>
            <span>Sire: <b>{{d.sire}}</b></span>
            <span>Dam: <b>{{d.dam}}</b></span>
            <span style="max-width: 200px; white-space: nowrap; overflow:hidden; text-overflow: ellipsis">Owners: <b>{{d.owners}}</b></span>
          </div>
          <div class="runnerStats">
            <div class="competitorStatContainer" v-if="d.runnerStatistics">
              <div>
                <p>
                  <b>Career</b>
                </p>
                <p>
                  {{d.runnerStatistics.all}}
                </p>
              </div>
              <div>
                <p>
                  <b>1stUp</b>
                </p>
                <p>
                  {{d.runnerStatistics.firstUp}}
                </p>
              </div>
              <div>
                <p>
                  <b>2ndUp</b>
                </p>
                <p>
                  {{d.runnerStatistics.secondUp}}
                </p>
              </div>
              <div v-if="!greyhoundMeeting(singleRunner)">
                <p>
                  <b>3rdUp</b>
                </p>
                <p>
                  {{d.runnerStatistics.thirdUp}}
                </p>
              </div>
              <div v-if="!greyhoundMeeting(singleRunner)">
                <p>
                  <b>4thUp</b>
                </p>
                <p>
                  {{d.runnerStatistics.fourthUp}}
                </p>
              </div>
              <div>
                <p>
                  <b>This Prep</b>
                </p>
                <p>
                  <!--                            <b>{{d.runnerStatistics.thisCampaign.numberOfRuns}}:</b>-->
                  <b>0:</b>
                  0-0-0
                  <!--                            {{d.runnerStatistics.thisCampaign.firsts}}-{{d.runnerStatistics.thisCampaign.seconds}}-{{d.runnerStatistics.thisCampaign.thirds}}-->
                </p>
              </div>
              <div>
                <p>
                  <b>Track</b>
                </p>
                <p>
                  {{d.runnerStatistics.track}}
                </p>
              </div>
              <div>
                <div>
                  <p>
                    <b>Distance</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.distance}}
                  </p>
                </div>
              </div>
              <div>
                <p>
                  <b>Trk.Dist</b>
                </p>
                <p>
                  {{d.runnerStatistics.trackDistance}}
                </p>
              </div>
              <template v-if="!greyhoundMeeting(singleRunner)">
                <div>
                  <p>
                    <b>Firm</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.conditions.firm}}
                  </p>
                </div>
                <div>
                  <p>
                    <b>Good</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.conditions.good}}
                  </p>
                </div>
                <div>
                  <p>
                    <b>Soft</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.conditions.soft}}
                  </p>
                </div>
                <div>
                  <p>
                    <b>Heavy</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.conditions.heavy}}
                  </p>
                </div>
                <div>
                  <p>
                    <b>Synthetic</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.conditions.synthetic}}
                  </p>
                </div>
                <div>
                  <p>
                    <b>Night</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.conditions.night}}
                  </p>
                </div>
              </template>
            </div>
          </div>
          <div class="runnerForm" v-if="checkForForm(singleRunner)">
            <v-simple-table
                :class="[bookie + '-style']"
                class="simpleTable"
                dense
                style="width: 100%; margin-left: 0px; background: none"
            >
              <tbody
                  v-for="(b, index) in mutateDataForm(d.formHistory)"
                  :key="index"
              >
              <tr style="padding-bottom: 2px;">
                <td class="text-left pl-2">{{b.finishingPosition}} / {{b.starters}}</td>
                <td class="text-right pr-2">{{Math.abs(b.margin)}}L</td>
                <td class="text-left">{{b.distance}}</td>
                <td class="text-left pl-2" style="font-size: 12px; white-space: nowrap">{{b.track}}</td>
                <td class="text-left">{{b.class}}</td>
                <td class="pl-1">${{numeral(b.prizeTotal).format('0,0')}}</td>
                <td class="pl-2 text-center">{{format(new Date(b.date), 'dd MMM yy')}}</td>
                <td class="text-left pl-1" :class="['color-' + checkTrackCond(b.trackCondition)]">
                  <b>{{checkTrackCond(b.trackCondition)}}</b>
                </td>
                <td class="pl-2 text-right">${{b.startingPrice}}</td>
              </tr>
              </tbody>
            </v-simple-table>
          </div>
          <div v-else class="shortFormContainer">
            <span class="caption grey--text font-weight-thin">Sorry, there is no form available for this runner.</span>
          </div>
        </div>
      </div>
    </template>
  </div>
  <div :class="[bookie + '-style']" v-else-if="Object.keys(singleRunner).length > 0 && isMobile">
    <template v-for="d in singleRunner.competitors">
      <div v-if="d.tabNo == runnerNo" :key="d.tabNo" id="iFrameBox" style="background: none">
        <div class="shortFormContainer">
          <div class="runnerInfo" style="display: flex; justify-content: space-evenly">
            <span>Age: <b>{{d.age}}</b></span>
            <span>Sex: <b>{{d.sex}}</b></span>
            <span>Colour: <b>{{ d.colour.toUpperCase() }}</b></span>
            <span>Sire: <b>{{d.sire}}</b></span>
            <span>Dam: <b>{{d.dam}}</b></span>
<!--            <span style="max-width: 200px; white-space: nowrap; overflow:hidden; text-overflow: ellipsis">Owners: <b>{{d.owners}}</b></span>-->
          </div>
          <div class="runnerStats">
            <div class="competitorStatContainerMobile" v-if="d.runnerStatistics">
              <div>
                <p>
                  <b>Career</b>
                </p>
                <p>
                  {{d.runnerStatistics.all}}
                </p>
              </div>
              <div>
                <p>
                  <b>1stUp</b>
                </p>
                <p>
                  {{d.runnerStatistics.firstUp}}
                </p>
              </div>
              <div>
                <p>
                  <b>2ndUp</b>
                </p>
                <p>
                  {{d.runnerStatistics.secondUp}}
                </p>
              </div>
              <div v-if="!greyhoundMeeting(singleRunner)">
                <p>
                  <b>3rdUp</b>
                </p>
                <p>
                  {{d.runnerStatistics.thirdUp}}
                </p>
              </div>
              <div v-if="!greyhoundMeeting(singleRunner)">
                <p>
                  <b>4thUp</b>
                </p>
                <p>
                  {{d.runnerStatistics.fourthUp}}
                </p>
              </div>
              <div>
                <p>
                  <b>Prep</b>
                </p>
                <p>
                  <!--                            <b>{{d.runnerStatistics.thisCampaign.numberOfRuns}}:</b>-->
                  <b>0:</b>
                  0-0-0
                  <!--                            {{d.runnerStatistics.thisCampaign.firsts}}-{{d.runnerStatistics.thisCampaign.seconds}}-{{d.runnerStatistics.thisCampaign.thirds}}-->
                </p>
              </div>
              <div>
                <p>
                  <b>Track</b>
                </p>
                <p>
                  {{d.runnerStatistics.track}}
                </p>
              </div>
              <div>
                <div>
                  <p>
                    <b>Distance</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.distance}}
                  </p>
                </div>
              </div>
              <div>
                <p>
                  <b>Trk.Dist</b>
                </p>
                <p>
                  {{d.runnerStatistics.trackDistance}}
                </p>
              </div>
              <template v-if="!greyhoundMeeting(singleRunner)">
                <div>
                  <p>
                    <b>Firm</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.conditions.firm}}
                  </p>
                </div>
                <div>
                  <p>
                    <b>Good</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.conditions.good}}
                  </p>
                </div>
                <div>
                  <p>
                    <b>Soft</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.conditions.soft}}
                  </p>
                </div>
                <div>
                  <p>
                    <b>Heavy</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.conditions.heavy}}
                  </p>
                </div>
                <div>
                  <p>
                    <b>Synthetic</b>
                  </p>
                  <p>
                    {{d.runnerStatistics.conditions.synthetic}}
                  </p>
                </div>
              </template>
            </div>
          </div>
          <div class="runnerForm" v-if="checkForForm(singleRunner)">
            <v-simple-table
              :class="[bookie + '-style']"
              class="simpleTable"
              dense
              style="width: 100%; margin-left: 0px; background: none"
            >
              <tbody
                v-for="(b, index) in mutateDataForm(d.formHistory)"
                :key="index"
              >
              <tr style="padding-bottom: 2px;">
                <td class="text-left pl-2 pr-2">{{b.finishingPosition}} / {{b.starters}}</td>
                <td class="text-right pr-2">{{Math.abs(b.margin)}}L</td>
                <td class="text-left pl-2">{{b.distance}}</td>
                <td class="text-left pl-2" style="font-size: 12px; white-space: nowrap; max-width: 50px; overflow: hidden; text-overflow: ellipsis">{{b.track}}</td>
                <td class="text-left pl-2">{{b.class}}</td>
                <td class="pl-2 text-center">{{format(new Date(b.date), 'dd/MM/yy')}}</td>
                <td class="text-left pl-1" :class="['color-' + checkTrackCond(b.trackCondition)]">
                  <b>{{checkTrackCond(b.trackCondition)}}</b>
                </td>
                <td class="pl-2 text-right">${{b.startingPrice}}</td>
              </tr>
              </tbody>
            </v-simple-table>
          </div>
          <div v-else class="shortFormContainer">
            <span class="caption grey--text font-weight-thin">Sorry, there is no form available for this runner.</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { format } from 'date-fns'
import ordinal from 'ordinal'
import numeral from 'numeral'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'SingleRunner',
  data () {
    return {
      format,
      ordinal,
      numeral
    }
  },
  created () {
    this.setStoreVariables()
    this.fetchSingleRunner()
    const bodyCSS = document.querySelector('body')
    bodyCSS.style.background = 'none'
    bodyCSS.style.maxWidth = 'none'
    bodyCSS.style.minWidth = '0px'

    window.addEventListener('message', function (event) {
      const eventData = event?.data

      if (eventData === 'FrameHeight') {
        const boxInterval = setInterval(() => {
          const box = document.querySelector('.shortFormContainer')
          if (box !== null) {
            clearInterval(boxInterval)
            event.source.postMessage({ FrameHeight: box.clientHeight }, '*')
            this.setClientVisibility('open') // for backwards compatibility for parent windows that aren't sending 'open'|'close' events
          }
        }, 100)
      } else if (['open', 'close'].includes(eventData)) this.setClientVisibility(eventData)
    })

    if (window.parent === window.top) this.setClientVisibility('open') // not in iframe set clientVisibilityOpen
  },
  computed: {
    ...mapState(['singleRunner', 'runnerNo', 'bookie']),
    ...mapGetters(['isMobile'])
  },
  methods: {
    ...mapActions(['fetchSingleRunner', 'setRouterVariables', 'setClientVisibility']),
    formAvailable (data) {
      return data.formHistory.length >= 1
    },
    greyhoundMeeting (data) {
      return data.meeting.type === 'GREYHOUND'
    },
    setStoreVariables () {
      const varObj = {
        gbsID: this.$route.params.id,
        raceNo: this.$route.params.raceNo,
        runnerNo: this.$route.params.runnerNo
      }
      this.setRouterVariables(varObj)
    },
    checkForForm (data) {
      if (data.competitors) {
        let formAvailable = 0
        // eslint-disable-next-line array-callback-return
        data.competitors.forEach((b) => {
          if (b.formHistory.length > 0) {
            formAvailable += 1
          }
        })
        return formAvailable !== 0
      }
    },
    mutateDataForm (data) {
      // eslint-disable-next-line array-callback-return
      data.map((b, index) => {
        if (index !== data.length - 1) {
          const nowTime = data[index].date
          const pastTimer = data[index + 1].date
          const nowTimeMili = new Date(nowTime).getTime()
          const pastTimeMili = new Date(pastTimer).getTime()
          const timeBetween = nowTimeMili - pastTimeMili
          const daysBetween = timeBetween / (1000 * 60 * 60 * 24)
          const daysFormatted = Math.floor(daysBetween)
          b.dsls = daysFormatted
        }
      })
      return data.slice(0, 5)
    },
    mutateTrackDistance (obj, track, distance) {
      let distanceTrackObj = {
        firsts: 0,
        key: `${track}, ${distance}`,
        numberOfRuns: 0,
        seconds: 0,
        thirds: 0
      }
      obj.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (b.key == `(${track}, ${distance})`) {
          distanceTrackObj = {
            firsts: b.firsts,
            key: b.key,
            numberOfRuns: b.numberOfRuns,
            seconds: b.seconds,
            thirds: b.thirds
          }
        }
      })
      return [distanceTrackObj]
    },
    mutateDistance (distance, data) {
      let distanceObj = {
        firsts: 0,
        key: data,
        numberOfRuns: 0,
        seconds: 0,
        thirds: 0
      }
      distance.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (b.key == data) {
          distanceObj = {
            firsts: b.firsts,
            key: b.key,
            numberOfRuns: b.numberOfRuns,
            seconds: b.seconds,
            thirds: b.thirds
          }
        }
      })
      return [distanceObj]
    },
    mutateTrack (track, data) {
      let trackObj = {
        firsts: 0,
        key: data,
        numberOfRuns: 0,
        seconds: 0,
        thirds: 0
      }
      track.forEach(b => {
        if (b.key === data) {
          trackObj = {
            firsts: b.firsts,
            key: b.key,
            numberOfRuns: b.numberOfRuns,
            seconds: b.seconds,
            thirds: b.thirds
          }
        }
      })
      return [trackObj]
    },
    mutateSurface (surface) {
      let syntheticNumberOfRuns = 0
      let syntheticFirsts = 0
      let syntheticSeconds = 0
      let syntheticThirds = 0
      let newKey = ''
      const surfaceObj = {}
      const syntheticObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Synthetic'
      }
      surfaceObj[syntheticObj.key] = syntheticObj
      surface?.forEach(b => {
        if (b.key.includes('Synthetic')) {
          syntheticNumberOfRuns += b.numberOfRuns
          syntheticFirsts += b.firsts
          syntheticSeconds += b.seconds
          syntheticThirds += b.thirds
        }
        newKey = b.key.split(/(\d+)/)
        if (newKey[0] === 'Synthetic') {
          const blah = {
            numberOfRuns: syntheticNumberOfRuns,
            firsts: syntheticFirsts,
            seconds: syntheticSeconds,
            thirds: syntheticThirds,
            key: newKey[0]
          }
          surfaceObj[blah.key] = blah
        }
      })
      return Object.values(surfaceObj)
    },
    mutateCondition (condition) {
      let firmNumberOfRuns = 0
      let firmFirsts = 0
      let firmSeconds = 0
      let firmThirds = 0
      let goodNumberOfRuns = 0
      let goodFirsts = 0
      let goodSeconds = 0
      let goodThirds = 0
      let heavyNumberOfRuns = 0
      let heavyFirsts = 0
      let heavySeconds = 0
      let heavyThirds = 0
      let softNumberOfRuns = 0
      let softFirsts = 0
      let softSeconds = 0
      let softThirds = 0
      let newKey = ''
      const conditionObj = {}
      const firmObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Firm'
      }
      conditionObj[firmObj.key] = firmObj
      const goodObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Good'
      }
      conditionObj[goodObj.key] = goodObj
      const softObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Soft'
      }
      conditionObj[softObj.key] = softObj
      const heavyObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Heavy'
      }
      conditionObj[heavyObj.key] = heavyObj
      condition.forEach(b => {
        if (b.key.includes('Firm')) {
          firmNumberOfRuns += b.numberOfRuns
          firmFirsts += b.firsts
          firmSeconds += b.seconds
          firmThirds += b.thirds
        }
        if (b.key.includes('Good')) {
          goodNumberOfRuns += b.numberOfRuns
          goodFirsts += b.firsts
          goodSeconds += b.seconds
          goodThirds += b.thirds
        }
        if (b.key.includes('Soft')) {
          softNumberOfRuns += b.numberOfRuns
          softFirsts += b.firsts
          softSeconds += b.seconds
          softThirds += b.thirds
        }
        if (b.key.includes('Heavy8')) {
          heavyNumberOfRuns += b.numberOfRuns
          heavyFirsts += b.firsts
          heavySeconds += b.seconds
          heavyThirds += b.thirds
        }
        newKey = b.key.split(/(\d+)/)
        if (newKey[0] === 'Firm') {
          const blah = {
            numberOfRuns: firmNumberOfRuns,
            firsts: firmFirsts,
            seconds: firmSeconds,
            thirds: firmThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
        if (newKey[0] === 'Good') {
          const blah = {
            numberOfRuns: goodNumberOfRuns,
            firsts: goodFirsts,
            seconds: goodSeconds,
            thirds: goodThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
        if (newKey[0] === 'Soft') {
          const blah = {
            numberOfRuns: softNumberOfRuns,
            firsts: softFirsts,
            seconds: softSeconds,
            thirds: softThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
        if (newKey[0] === 'Heavy') {
          const blah = {
            numberOfRuns: heavyNumberOfRuns,
            firsts: heavyFirsts,
            seconds: heavySeconds,
            thirds: heavyThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
      })
      return Object.values(conditionObj)
    },
    mutateConditionMobile (condition) {
      let firmNumberOfRuns = 0
      let firmFirsts = 0
      let firmSeconds = 0
      let firmThirds = 0
      let goodNumberOfRuns = 0
      let goodFirsts = 0
      let goodSeconds = 0
      let goodThirds = 0
      let heavyNumberOfRuns = 0
      let heavyFirsts = 0
      let heavySeconds = 0
      let heavyThirds = 0
      let softNumberOfRuns = 0
      let softFirsts = 0
      let softSeconds = 0
      let softThirds = 0
      let newKey = ''
      const conditionObj = {}
      const firmObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Firm'
      }
      conditionObj[firmObj.key] = firmObj
      const goodObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Good'
      }
      conditionObj[goodObj.key] = goodObj
      const softObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Soft'
      }
      conditionObj[softObj.key] = softObj
      const heavyObj = {
        numberOfRuns: 0,
        firsts: 0,
        seconds: 0,
        thirds: 0,
        key: 'Heavy'
      }
      conditionObj[heavyObj.key] = heavyObj
      condition.forEach(b => {
        if (b.key.includes('Firm')) {
          firmNumberOfRuns += b.numberOfRuns
          firmFirsts += b.firsts
          firmSeconds += b.seconds
          firmThirds += b.thirds
        }
        if (b.key.includes('Good')) {
          goodNumberOfRuns += b.numberOfRuns
          goodFirsts += b.firsts
          goodSeconds += b.seconds
          goodThirds += b.thirds
        }
        if (b.key.includes('Soft')) {
          softNumberOfRuns += b.numberOfRuns
          softFirsts += b.firsts
          softSeconds += b.seconds
          softThirds += b.thirds
        }
        if (b.key.includes('Heavy')) {
          heavyNumberOfRuns += b.numberOfRuns
          heavyFirsts += b.firsts
          heavySeconds += b.seconds
          heavyThirds += b.thirds
        }
        newKey = b.key.split(/(\d+)/)
        if (newKey[0] === 'Firm') {
          const blah = {
            numberOfRuns: firmNumberOfRuns,
            firsts: firmFirsts,
            seconds: firmSeconds,
            thirds: firmThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
        if (newKey[0] === 'Good') {
          const blah = {
            numberOfRuns: goodNumberOfRuns,
            firsts: goodFirsts,
            seconds: goodSeconds,
            thirds: goodThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
        if (newKey[0] === 'Soft') {
          const blah = {
            numberOfRuns: softNumberOfRuns,
            firsts: softFirsts,
            seconds: softSeconds,
            thirds: softThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
        if (newKey[0] === 'Heavy') {
          const blah = {
            numberOfRuns: heavyNumberOfRuns,
            firsts: heavyFirsts,
            seconds: heavySeconds,
            thirds: heavyThirds,
            key: newKey[0]
          }
          conditionObj[blah.key] = blah
        }
      })
      return Object.values(conditionObj)
    },
    checkTrackCond: function (condition) {
      switch (condition) {
        case 'FIRM1':
          return 'Firm1'
        case 'Firm1':
          return 'Firm1'
        case 'FIRM2':
          return 'Firm2'
        case 'Firm2':
          return 'Firm2'
        case 'GOOD3':
          return 'Good3'
        case 'Good3':
          return 'Good3'
        case 'GOOD4':
          return 'Good4'
        case 'Good4':
          return 'Good4'
        case 'SOFT5':
          return 'Soft5'
        case 'Soft5':
          return 'Soft5'
        case 'SOFT6':
          return 'Soft6'
        case 'Soft6':
          return 'Soft6'
        case 'SOFT7':
          return 'Soft7'
        case 'Soft7':
          return 'Soft7'
        case 'HEAVY8':
          return 'Heavy8'
        case 'Heavy8':
          return 'Heavy8'
        case 'HEAVY9':
          return 'Heavy9'
        case 'Heavy9':
          return 'Heavy9'
        case 'HEAVY10':
          return 'Heavy10'
        case 'Heavy10':
          return 'Heavy10'
        case 'SYNTHETIC' || 'Synthetic':
          return 'Synthetic'
        default:
          return condition
      }
    }
  }
}
</script>

<style>
.pronet-style {
  color: white !important;
}
.theme--light.v-application {
  background: none !important;
}
.simpleTable td {
  height: 20px !important;
  font-size: 11px !important;
  white-space: nowrap !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
p {
  padding: 0!important;
  margin: 0!important;
}
.competitorStatContainer {
  grid-area: stats;
  line-height: 25px;
  text-align: center;
  grid-gap: 5px;
  margin: 0;
  font-size: 11px;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
}
.competitorStatContainerMobile {
  grid-area: stats;
  line-height: 25px;
  text-align: center;
  grid-gap: 5px;
  margin: 0;
  font-size: 11px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.runnerInfo {
  grid-area: information;
  font-size: 11px;
}
.runnerStats {
  padding-top: 5px;
  padding-bottom: 10px;
  grid-area: statistics;
}
.runnerStats p {
  height: 20px;
}
.runnerForm {
  grid-area: form;
}
#iFrameBox {
  width: auto;
  max-width: 656px;
  /*min-width: 475px;*/
  height: auto;
}
.shortFormContainer {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: auto;
  grid-template-areas:
      "information"
      "statistics"
      "form";
  width: auto;
  max-width: 656px;
  height: auto;
}
</style>
